/* eslint-disable */
import { Bold, Button, Heading4, Text, useToast } from '@serodigital/ui-components';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { generateZoneSchedules, IZoneArray } from '../../helpers/scheduleHelper';
import { ColourCards } from '../colourCards';
import { Degree } from '../degree';
import { ZonesList } from './zones';
import { UIConfig } from '../../helpers/UIConfig';
import { HeatingScheduleModal, ISelectedSchedule } from './heatingScheduleModal';
import { IZone } from '../../views/bee/state/types';
import { HeatingSchedulesResponse } from '../../../../shared/api-clients/gql';

interface IScheduleProps {
  title: string;
  schedules: HeatingSchedulesResponse;
  zones?: IZone[];
}

export function HeatingSchedule({ title, schedules, zones }: IScheduleProps) {
  const [scheduleItems, setScheduleItems] = useState<IZoneArray>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState<ISelectedSchedule>(null);
  const { setToastMessage } = useToast();

  useEffect(() => {
    if (!schedules) return;
    const { zones } = generateZoneSchedules(schedules);
    setScheduleItems(zones);
  }, [schedules]);

  function onAddSchedule() {
    setIsModalOpen(true);
  }
  const hasSchedules = Object.keys(scheduleItems).length > 0;

  function handleCloseModal(message?: string) {
    setSelectedSchedule(null);
    setIsModalOpen(false);
    if (typeof message === 'string') {
      setToastMessage({ label: message, type: 'success', position: 'topCenter' });
    }
  }

  function onClickSchedule(schedule: ISelectedSchedule) {
    setSelectedSchedule(schedule);
    setIsModalOpen(true);
  }
  return (
    <div data-qa="schedules" className="w-full flex flex-col rounded-xl border border-grey-neutral p-20 ">
      <div className="flex flex-row justify-between">
        <Heading4 className="p-0 m-0">{title}</Heading4>
        {hasSchedules && (
          <Button data-qa="add-schedule-btn" onClick={onAddSchedule} kind="primary">
            Add another schedule
          </Button>
        )}
      </div>
      {!hasSchedules ? (
        <div className="flex items-center justify-center h-160 flex-col space-y-16">
          <Text>To get started add your first schedule</Text>
          <Button data-qa="new-schedule-btn" onClick={onAddSchedule} kind="primary">
            Add a schedule
          </Button>
        </div>
      ) : (
        <div>
          {zones.map(({ description, zone_id }) => (
            <ZonesList
              key={zone_id}
              zoneId={zone_id}
              zoneName={description}
              zones={scheduleItems[zone_id]}
              onClickSchedule={onClickSchedule}
            />
          ))}
        </div>
      )}
      <div className="flex flex-col">
        <Bold>Baseline Temps</Bold>
        <div className="flex flex-row flex-wrap">
          {zones.map(({ description, zone_id }) => (
            <div key={zone_id} className="m-8">
              <ColourCards
                key={zone_id}
                kind={'blue'}
                header={
                  <span className="flex">
                    {UIConfig.defaultSetpoint}
                    <Degree />
                  </span>
                }
                label={description}
              />
            </div>
          ))}
        </div>
      </div>
      {isModalOpen && (
        <HeatingScheduleModal
          title={'Heating - Add Time, Days And Temp'}
          isOpen={isModalOpen}
          zoneSchedules={scheduleItems}
          zones={zones}
          handleCloseModal={handleCloseModal}
          selectedSchedule={selectedSchedule}
        />
      )}
    </div>
  );
}
